var React = require('react');

function BlobBackground2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#0083A0","d":"M387.34 18.954c33.684 22.571 52.435 68.062 55.907 110.774 3.82 43.06-7.986 83.341-11.112 136.471-3.472 53.13 1.737 119.109-26.39 161.127-28.127 41.67-89.243 59.728-147.928 56.255-58.685-3.473-114.939-28.128-159.734-64.589-44.795-36.462-78.478-84.731-91.674-136.819C-6.786 230.085.506 173.83 27.244 134.59c27.086-39.24 73.617-61.812 114.939-81.953 41.323-20.14 77.437-37.85 119.801-46.879C304.348-3.27 353.31-3.618 387.34 18.954Z"}));
}

BlobBackground2.defaultProps = {"width":"268","height":"484","fill":"none","viewBox":"0 0 268 484"};

module.exports = BlobBackground2;

BlobBackground2.default = BlobBackground2;
